import {
  Box,
  Button,
  Center,
  HStack,
  Input,
  Link,
  Text,
  Textarea,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import { FC, FormEvent, useEffect, useState } from 'react';
import { SendTafMessageOptions } from '@frx/frx-services';
import { Modal } from '../modal';
import { useIsMobile } from '../../hooks';

export interface DonorSendThankyouModalProps {
  donorName: string;
  isOpen: boolean;
  onClosed: () => void;
  onCancel: () => void;
  onSentThankyou: (
    messageOpts: Pick<SendTafMessageOptions, 'subject' | 'message_body'>
  ) => void;
}

export const DonorSendThankyouModal: FC<DonorSendThankyouModalProps> = (
  props
): JSX.Element => {
  const { donorName, isOpen, onClosed, onCancel, onSentThankyou } = props;
  const { onClose } = useDisclosure();
  const isMobile = useIsMobile();
  const [internalIsOpen, setInternalIsOpen] = useState(isOpen);

  useEffect(() => {
    setInternalIsOpen(isOpen);
  }, [isOpen]);

  const defaultSubject = 'Thank you for your generous gift';
  const defaultMessage = `Thank you for your generous donation supporting the kids of St. Jude.

St. Jude is working to drive the overall survival rate for childhood cancer to 90 percent, and we won't stop until no child dies from cancer.

Thanks to your donation, we're one step closer!`;
  const [message, setMessage] = useState(defaultMessage);
  const [subject, setSubject] = useState(defaultSubject);

  const onSubjectChange = (event: FormEvent<HTMLInputElement>): void => {
    const val: string = event.currentTarget.value;
    setSubject(val);
  };
  const onMessageChange = (event: FormEvent<HTMLTextAreaElement>): void => {
    const val: string = event.currentTarget.value;
    setMessage(val);
  };
  return (
    <Modal
      isOpen={internalIsOpen}
      onClose={() => {
        setInternalIsOpen(false);
        onClose();
        onClosed();
      }}
      size={isMobile ? 'sm' : 'lg'}
    >
      <VStack align="left" spacing="1.5rem" minH="700px">
        <Box>
          <Box>Please write your message to</Box>
          <Text fontWeight="bold" fontSize="xl">
            {donorName}
          </Text>
        </Box>
        <Text fontStyle="italic">
          Sending a personalized thank you message your donors will make them
          more likely to support you in the future
        </Text>
        <Box>
          <Text>To:</Text>
          <Text fontWeight="bold" fontSize="md">
            {donorName}
          </Text>
        </Box>
        <Box>
          <Text mb="0.3rem">Subject</Text>
          <Input onChange={onSubjectChange} value={subject} />
        </Box>
        <Box>
          <Text mb="0.3rem">Message body</Text>
          <Textarea minH="200px" onChange={onMessageChange} value={message} />
        </Box>
        <Center>
          <Button
            width={isMobile ? '100%' : '60%'}
            colorScheme="blue"
            onClick={() => onSentThankyou({ subject, message_body: message })}
          >
            Send
          </Button>
        </Center>
        <Box>
          <Center>
            <HStack>
              <Link textDecoration="none" onClick={onCancel}>
                Cancel
              </Link>
            </HStack>
          </Center>
        </Box>
      </VStack>
    </Modal>
  );
};
